import React from 'react';
export function Card({
  children,
  className = '',
  onClick
}) {
  return <div className={`bg-white rounded-lg shadow-sm border border-gray-100 p-4 ${className} ${onClick ? 'cursor-pointer transition-all duration-200 hover:border-gray-200 hover:shadow-md active:scale-[0.98]' : ''}`} onClick={onClick} data-id="element-29">
      {children}
    </div>;
}